import React, {Component} from 'react';
import {connect} from 'react-redux';
import {FooterWithRouter, DefaultFooterTitle} from './components/Footer';
import {View3D} from './components/View3D';
import {Documents} from './components/Documents';
import {Details} from './completion/Details';
import {AccessoryPicker} from './accessory/AccessoryPicker';
import {AccessoryFabric} from './accessory/AccessoryFabric';
import {AccessoryGranite} from './granite/AccessoryGranitePicker';
import {UndoRedo} from "./components/UndoRedo";
import * as configurationActions from "../../actions/configurationActions";
import * as apiService from "../../services/api.service";
import { bindActionCreators } from "redux";
import { isSmartphone } from '../../services/domFunctions';
import * as updateConfigurationActions from '../../actions/updateConfigurationActions';
import { isConfigRequested } from '../../services/configurationWarningChecks'
import { TranslationContext } from "../../context/TranslationContext";
import {getStore} from '../../store';
import {Steps} from "intro.js-react";
import {introIsAvailable} from "../helpers/introHelpers"

export const kinds = {
  'Vase': {
    id: 'Vase',
    label: 'Vases',
  },
  'Jardinière': {
    id: 'Jardinière',
    label: 'Jardinières',
  },
  'Divers': {
    id: 'Divers',
    label: 'Autres...',
  },
};

class ConfiguratorAccessoryComponent extends Component {
  constructor(props) {
    super(props);
    this.stepsRef = React.createRef();
    this.skipTutorialAccessory = this.skipTutorialAccessory.bind(this);
    window["skipTutorialAccessory"] = this.skipTutorialAccessory;
  }

  static contextType = TranslationContext;
  state = {
    drawing: true,
    stepsEnabled: true,
    initialStep: 0,
    steps: [],
    flagCloseTutorial: false
  };
  createInitialAccessory = () => {
    const accessory = this.props.catalog.selectedAccessory;
    const granite = this.props.catalog.selectedAccessoryGranite;
    if (accessory !== null && granite !== null && this.props.configurator.current.configuration.accessories.length<=0 ){
      this.props.actions.addAccessory(accessory, granite);
    }
  }
  async componentDidMount (){
    if (!this.props.configurator.accessories){
      const accessories = await apiService.get('/api/catalog/accessories');
      this.props.configActions.storeAccessories(accessories);
    }
    this.initializeIconColor();
    // this.launchIntro(true);
  }

  onBeforeExit = (stepIndex) => {
    const nbSteps = this.state.steps.length - 1
    if (nbSteps !== -1 && this.state.flagCloseTutorial === false) {
      if (stepIndex !== nbSteps) {
        const stepsRef = this.stepsRef.current.introJs
        stepsRef.nextStep();
        return false;
      }
    }
  };

  onExit = () => {
    this.setState({ steps: [] });
  };

  toggleStepsInModal = (modal) => {
    this.setState({flagCloseTutorial: false});
    if (modal) { this.launchIntro(false, modal); }
  };

  toggleSteps = () => {
    this.setState({flagCloseTutorial: false});
    const { steps } = this.state;
    if (steps.length < 1) {
      this.launchIntro(false);
    } else {
      this.setState(prevState => ({ stepsEnabled: !prevState.stepsEnabled }));
    }
  };

  launchIntro = (loadEvent=false, modal=false) => {
    this.setState({flagCloseTutorial: false});
    const t = this.context;
    const { configIntro } = this.props.configurator;

    const intro = loadEvent
      ? modal ? configIntro.find(element => element.step === "accessory" && element.is_modal && element.modal == modal && element.views < 1) : configIntro.find(element => element.step === "accessory" && !element.is_modal && element.views < 1)
      : modal ? configIntro.find(element => element.step === "accessory" && element.is_modal && element.modal == modal) : configIntro.find(element => element.step === "accessory" && !element.is_modal)

    if (intro) {
      const data = intro.data.map(dataItem => {
        const lastSegment = dataItem.intro.split(".").pop();
        dataItem.intro = t(lastSegment);
        return dataItem;
      }).sort((a, b) => {
        return a.order - b.order;
      });

      const familyUser = getStore().getState().user
      const member_id = familyUser && familyUser.id ? familyUser.id : null
      // if (loadEvent && member_id) this.props.configActions.addReadOnboarding(member_id, intro.id);
      if (member_id) this.props.configActions.addReadOnboarding(member_id, intro.id);
      this.setState({ steps: data });
    }
  };

  skipTutorialAccessory = () => {
    this.setState({flagCloseTutorial: true});
  };

  // Initialize icons for checkbox
  initializeIconColor () {
    const status = this.state.drawing;
    const root = document.documentElement;
    const color = (status === true) 
      ? getComputedStyle(root).getPropertyValue("--secondary2")
      : getComputedStyle(root).getPropertyValue("--secondary2-hover") 
    const encodedColor = encodeURIComponent(color);
    const styleTag = document.createElement("style");
    styleTag.textContent = `
      :root {
        --checked-granite-icon: url("data:image/svg+xml,%3Csvg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M6.37728 11.9219L5.4716 11.0162C4.97141 10.516 4.97141 9.70505 5.4716 9.20486L9.09432 5.58214C9.59451 5.08195 10.4055 5.08195 10.9057 5.58214L14.5284 9.20486C15.0286 9.70505 15.0286 10.516 14.5284 11.0162L13.6227 11.9219M6.37728 8.07942L5.4716 7.17374C4.97141 6.67355 4.97141 5.86258 5.4716 5.36238L9.09432 1.73966C9.59451 1.23947 10.4055 1.23947 10.9057 1.73966L14.5284 5.36238C15.0286 5.86258 15.0286 6.67355 14.5284 7.17374L13.6227 8.07942M5.4716 14.6389L9.09432 18.2617C9.59451 18.7619 10.4055 18.7619 10.9057 18.2617L14.5284 14.6389C15.0286 14.1387 15.0286 13.3278 14.5284 12.8276L10.9057 9.20486C10.4055 8.70467 9.59451 8.70467 9.09432 9.20486L5.4716 12.8276C4.97141 13.3278 4.97141 14.1387 5.4716 14.6389Z' stroke='${encodedColor}' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E%0A");
        --unchecked-granite-icon: url("data:image/svg+xml,%3Csvg width='17.44165mm' height='18.5215mm' viewBox='0 0 17.44165 18.5215' version='1.1' id='svg5' xml:space='preserve' xmlns:inkscape='http://www.inkscape.org/namespaces/inkscape' xmlns:sodipodi='http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd' xmlns='http://www.w3.org/2000/svg' xmlns:svg='http://www.w3.org/2000/svg'%3E%3Csodipodi:namedview id='namedview7' pagecolor='%23ffffff' bordercolor='%23000000' borderopacity='0.25' inkscape:showpageshadow='2' inkscape:pageopacity='0.0' inkscape:pagecheckerboard='0' inkscape:deskcolor='%23d1d1d1' inkscape:document-units='mm' showgrid='false' /%3E%3Cdefs id='defs2' /%3E%3Cg inkscape:groupmode='layer' id='layer2' inkscape:label='granit' inkscape:export-filename='layer2.svg' inkscape:export-xdpi='96' inkscape:export-ydpi='96' transform='translate(-134.5972,-149.01777)'%3E%3Cpath id='path5099' style='color:%23000000;fill:${encodedColor};fill-opacity:1;stroke-linecap:round;stroke-linejoin:round;-inkscape-stroke:none' d='m 143.41399,149.01778 c -0.46317,0 -0.92699,0.17457 -1.27745,0.52503 l -3.67161,3.67419 c -0.70091,0.70091 -0.70091,1.85346 0,2.55437 l 0.66973,0.67024 -0.66973,0.6718 c -0.70093,0.70092 -0.70092,1.85188 0,2.55281 l 0.56069,0.56018 -0.56069,0.56068 c -0.70091,0.70091 -0.70091,1.85191 0,2.55282 l 0.28216,0.28267 0.71727,-0.71675 -0.28267,-0.28267 c -0.31345,-0.31345 -0.31345,-0.80586 0,-1.11931 l 0.91777,-0.91778 2.7559,-2.7559 c 0.31343,-0.3134 0.80588,-0.3134 1.11931,0 l 0.28216,0.28215 0.71727,-0.71623 -0.28267,-0.28267 c -0.70093,-0.70086 -1.85396,-0.70086 -2.55489,0 l -2.39417,2.39623 -0.56068,-0.56017 c -0.31343,-0.31344 -0.31343,-0.80589 0,-1.11931 l 3.67367,-3.67368 c 0.31344,-0.31344 0.80587,-0.31344 1.11931,0 l 2.11925,2.11925 0.71676,-0.71675 -2.11925,-2.11977 c -0.70093,-0.70092 -1.85397,-0.70092 -2.55489,0 l -2.28513,2.28565 -0.66972,-0.67231 c -0.31345,-0.31345 -0.31345,-0.80534 0,-1.11879 l 3.67367,-3.6742 c 0.31343,-0.31343 0.80587,-0.31343 1.11931,0 l 3.67368,3.6742 c 0.15498,0.15497 0.23289,0.35376 0.23461,0.55293 l 0.81287,-0.81287 c -0.0835,-0.1651 -0.19349,-0.31958 -0.33073,-0.45682 l -3.67367,-3.67419 c -0.35047,-0.35046 -0.81427,-0.52503 -1.27744,-0.52503 z m 5.16712,6.49159 -1.62677,1.62678 0.69401,0.69401 c 0.31342,0.31342 0.31342,0.80588 0,1.11931 l -0.56069,0.56017 -1.25367,-1.25367 -0.71623,0.71727 1.61075,1.61076 0.002,0.002 0.91777,0.91778 c 0.31344,0.31344 0.31344,0.80586 0,1.11931 l -3.67368,3.67368 c -0.31344,0.31344 -0.80587,0.31344 -1.11931,0 l -2.53111,-2.53112 -0.71675,0.71727 2.52904,2.5306 c 0.70092,0.70092 1.85396,0.70092 2.55489,0 l 3.67367,-3.67368 c 0.7009,-0.70091 0.7009,-1.85191 0,-2.55282 l -0.56017,-0.56068 0.56017,-0.56018 c 0.70092,-0.70093 0.70092,-1.85189 0,-2.55281 l -0.67179,-0.6718 0.67179,-0.67024 c 0.0816,-0.0816 0.15339,-0.16952 0.21601,-0.262 z' /%3E%3Cpath style='color:%23000000;fill:${encodedColor};fill-opacity:1;stroke:none;stroke-width:0.811248;stroke-linecap:round;stroke-linejoin:round;-inkscape-stroke:none' d='m 151.00031,149.73537 -16.22495,16.22496 a 0.60843569,0.60843574 0 0 0 0,0.86036 0.60843569,0.60843574 0 0 0 0.86036,0 l 16.22496,-16.22495 a 0.60843569,0.60843574 0 0 0 0,-0.86037 0.60843569,0.60843574 0 0 0 -0.86037,0 z' id='path5087' inkscape:label='line dark' /%3E%3C/g%3E%3C/svg%3E");
      }
    `;
    document.head.appendChild(styleTag);
  }

  componentDidUpdate(){
    this.initializeIconColor();
  }

  onToggleView = () => {
    this.setState({
      drawing: !this.state.drawing
    })
  };

  render() {
    const t = this.context;
    const { configuration, configurator } = this.props;
    const { stepsEnabled, initialStep, steps } = this.state;
    const options = {
      tooltipClass: "customTooltip",
      showButtons: false,
      exitOnOverlayClick: true,
      showBullets: true,
      keyboardNavigation: false,
      skipLabel: `
        <a href="#" class="close-intro" onclick='window[\"skipTutorialAccessory\"]()'>
        <span>Quitter le didacticiel</span>
        <div class="close-intro-icon">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M22.5836 1.19444L1.19472 22.5833M22.5836 22.5833L1.19472 1.19444" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
      </a>`
    };

    return (
      <div className="ConfigurationAccessories">
        <AccessoryFabric drawing={this.state.drawing}
                         onReady={()=>this.setState({fabricReady: true})}/>
        <AccessoryGranite/> 
        {this.state.fabricReady ? (
          <>
          {steps.length > 0 && (
            <Steps
              ref={this.stepsRef}
              options={options}
              enabled={stepsEnabled}
              steps={steps}
              initialStep={initialStep}
              onBeforeExit={this.onBeforeExit}
              onExit={this.onExit}
              onStart={this.onStart}
            />
          )}
          <div className="left-buttons">
            <div className="left-buttons-container">
              <div className="btn-wrapper">
                <AccessoryPicker 
                  toggleSteps={this.toggleStepsInModal}
                  launchIntro={this.launchIntro}
                  madalName="AccessoryPicker"
                  key="Vase" 
                  kind='Vase' 
                  buttonIcon="accessory-vase-icon" 
                  buttonClassName="btn-config-secondary config-button-background text-dark config-button-hover" />
              </div>
              <div className="btn-wrapper">
                <AccessoryPicker 
                  toggleSteps={this.toggleStepsInModal}
                  launchIntro={this.launchIntro}
                  madalName="AccessoryPicker"
                  key="Jardinière" 
                  kind='Jardinière' 
                  buttonIcon="accessory-box-icon" 
                  buttonClassName="btn-config-secondary config-button-background text-dark config-button-hover" />
              </div>
              <div className="btn-wrapper">
                <AccessoryPicker 
                  toggleSteps={this.toggleStepsInModal}
                  launchIntro={this.launchIntro}
                  madalName="AccessoryPicker"
                  key="Divers" 
                  kind='Divers' 
                  buttonIcon="other-icon" 
                  buttonClassName="btn-config-secondary config-button-background text-dark config-button-hover" />
              </div>

              {/* <button className={`SquareButton SwitchRender ${isConfigRequested() && 'disabled'}`} onClick={this.onToggleView} disabled={isConfigRequested()}>
                Avec / sans rendu granit
              </button> */}

              <div className={`cfg-switch mb-5 ${isConfigRequested() ? 'disabled' : ''}`}>
                <label>
                  <input 
                    checked={!this.state.drawing} 
                    type="checkbox" 
                    disabled={isConfigRequested()} 
                    onChange={this.onToggleView} />
                  <span className="granite"></span>
                </label>
                <div className="text-content text-dark">
                  { t("config3d_actionbuttons_granittoggle") || "Granits" }
                </div>
              </div>

              {introIsAvailable("accessory") &&
                <div className='d-flex flex-column align-items-center'>
                  <span onClick={() => this.toggleSteps()} className="open-tutorial question-circle-icon icon icon-large mb-2"></span>
                  <span className="info-tutorial text-dark ">visite guidée de la page</span>
                </div>
              }
            </div>
          </div>
          </>
        )
          : <div className="fabricSpinner"/>}
        
        {!isSmartphone() && (
        <div className="right-buttons">
          <div className="right-buttons-container">
            <View3D />
            <Documents />
            <Details />
            <UndoRedo />
          </div>
        </div>
        )}

        <FooterWithRouter footerLinks={this.props.footerLinks}>
          <DefaultFooterTitle accessories={configurator.accessories} configuration={configuration}/>
          {isSmartphone() && (
            <>
            <p className="Face">Vue de dessus</p>
            <div className="d-flex justify-content-around justify-content-around">
              <View3D />
              <Documents />
              <Details />
            </div>
            </>
          )}  
        </FooterWithRouter>

      </div>
    );
  }
}

export const ConfiguratorAccessory = connect(
  (state) => ({
    configurator: state.configurator,
    configuration: state.configurator.current.configuration,
    catalog: state.catalog,
  }),
  (dispatch) => ({
    configActions: bindActionCreators(configurationActions, dispatch),
    actions: bindActionCreators(updateConfigurationActions, dispatch),
})
)(ConfiguratorAccessoryComponent);

